<template>
  <div class="general-info">
    <div class="general-info__container">
      <div class="general-info__row">
        <div v-if="showDynamicMenu" class="floating-menu">
          <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
        </div>
        <div class="general-info__column general-info__margin-bottom">
          <div class="general-info__title">
            <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">Режим работы</h1>
          </div>
          <div class="general-info__schedule">
            <AppScheduleTable/>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import AppScheduleTable from '@/components/ScheduleTable.vue'
import DynamicMenu from "@/components/DynamicMenu.vue";
import menuItemsApi from "@/api/menuItems";

export default {
    name: "AppSchedule",
    components: {DynamicMenu, AppScheduleTable},
    metaInfo() {
      return {
        title: 'Режим работы | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Режим работы. Подробная информация о Алтайском краевом клиническом перинатальном центре ДАР.'
          },
          {
            name: 'keywords',
            content: 'Алтайский краевой клинический перинатальный центр'
          }
        ]
      };
    },
    data() {
      return {
        linksDepartment: 'about/schedule',
        dynamicMenuItems: [],
      }
    },
    computed: {
      showDynamicMenu() {
        return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
      }
    },
    methods: {
      async loadSiblingsForMenu() {
        try {
          const response = await menuItemsApi.getSiblingsByTo('/about/schedule');

          if (response.data.status === "SUCCESS") {
            this.dynamicMenuItems = response.data.result
                .map(item => {
                  const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

                  return {
                    text: item.label,
                    link: item.to,
                    slug: slug,
                    active: slug === this.currentPath,
                    id: item.id,
                    order: item.order || 0
                  };
                })
                .sort((a, b) => (a.order || 0) - (b.order || 0));
          }
        } catch (error) {
          console.error('Ошибка при загрузке меню:', error);
        }
      }
    },
    mounted() {
      this.loadSiblingsForMenu();
    }
  };
</script>
